module.exports = __webpack_public_path__ + "img/banner-h5.3a074da7.png";